export const nestedRoutes = {
  home: '.',
  costEstimates: 'cost-estimates',
  budgets: 'budgets'
}

export const routes = {
  root: '/',
  complexRoot: '/complex',
  livingComplex: (livingComplexId = ':livingComplexId?') =>
    `${routes.complexRoot}/${livingComplexId}`,
  home: (livingComplexId = ':livingComplexId?') =>
    routes.livingComplex(livingComplexId),
  costEstimates: (livingComplexId = ':livingComplexId?') =>
    `${routes.livingComplex(livingComplexId)}/${nestedRoutes.costEstimates}`,
  budgets: (livingComplexId = ':livingComplexId?') =>
    `${routes.livingComplex(livingComplexId)}/${nestedRoutes.budgets}`,
  authCallback: '/auth/callback',
  error: (errorCode = ':errorCode?') => `/e/${errorCode}`
}
